import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { UtilsService } from 'core/utils/utils.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { TrackingInfo } from 'src/app/modules/crm/dashboard/entities/tracking-info';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-order-tracking',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss'],
  standalone: false
})
export class OrderTrackingComponent implements OnInit {
  appStrings: AppLocalization;
  trackingNumberList: TrackingInfo[];
  orderNumber: string;
  displayedColumns: string[] = ['trackingNumber', 'carrier', 'action'];
  isMobile = false;

  private specialCarriers = ['UPS', 'FEDEX'];

  constructor(
    public dialogRef: MatDialogRef<OrderTrackingComponent>,
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService,
    private notificationService: NotificationService,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private deviceService: DeviceDetectorService
  ) {
    this.trackingNumberList = data.orderTrackingList;
    this.orderNumber = this.data.orderNumber;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
  }

  close(): void {
    this.dialogRef.close();
  }

  openExternalTracking(trackingDetails: TrackingInfo) {
    this.copyOrderTracking(trackingDetails);
    setTimeout(() => {
      this.buildSearchUrl({ ...trackingDetails });
    }, 1500);
  }

  private buildSearchUrl(trackingDetails: TrackingInfo) {
    this.specialCarriers.forEach(specialCarrier => {
      if (trackingDetails.carrier.toUpperCase().includes(specialCarrier)) {
        trackingDetails.carrier = specialCarrier;
      }
    });
    this.invoicesService.trackOrder(trackingDetails);
  }

  private copyOrderTracking(trackingDetails) {
    this.utilsService.copyTextToClipboard(trackingDetails.trackingNumber);
    this.notificationService.showNotification(this.appStrings.invoice_trackingClipboardNotification, NotificationType.Warning, false, true);
  }

}
